// https://habrahabr.ru/post/245049/
// http://stackoverflow.com/questions/22537311/angular-ui-router-login-authentication
// http://plnkr.co/edit/UkHDqFD8P7tTEqSaCOcc?p=preview
// https://github.com/sahat/satellizer#installation

var angular = require('angular');
var satellizer = require('satellizer');


var app = angular.module('amt_admin.auth', [
    'satellizer',
    'ui.router'
]);

var login_tpl = require('./resources/login.html');
app.run(['$templateCache', function ($templateCache) {
    $templateCache.put('amt_admin/login.html', login_tpl);
}]);

app.service('currentUser', ['$auth', '$http', function ($auth, $http) {
    this.current_user_info = null;

    return {
        data: function () {
            return this.current_user_info
        },
        update: function (info) {
            this.current_user_info = info
        },
        email: function () {
            return this.current_user_info.email
        },
        can: function (role_or_action) {
            return role_or_action == 'any' ? true : this.current_user_info.permissions[role_or_action]
        }
    }
}]);

app.config(['$stateProvider', '$urlRouterProvider', '$authProvider',
    function ($stateProvider, $urlRouterProvider, $authProvider) {

        /**
         * Helper auth functions
         */

        $authProvider.loginUrl = '/_auth/login';
        $authProvider.signupUrl = '/_auth/signup';
        $authProvider.unlinkUrl = '/_auth/unlink/';

        /**
         * App routes
         */
        $stateProvider
            .state('login', {
                url: '/login?state&state_params',
                templateUrl: 'amt_admin/login.html',
                controller: ['$scope', '$location', '$auth', '$state', '$stateParams',
                    function ($scope, $location, $auth, $state, $stateParams) {
                        $scope.error = "";
                        $scope.login = function () {
                            $auth.login($scope.user)
                                .then(function () {
                                    if ($stateParams.state){
                                       var state_params = $stateParams.state_params
                                        ? angular.fromJson($stateParams.state_params)
                                        : {};
                                        $state.go($stateParams.state || 'amt.main', state_params)

                                    }else{
                                        $location.path('/')
                                    }
                                })
                                .catch(function (error) {
                                    $scope.error = error.data.message;
                                });
                        };
                        $scope.authenticate = function (provider) {
                            $auth.authenticate(provider)
                                .then(function () {
                                    $location.path('/');
                                })
                                .catch(function (error) {
                                    if (error.message) {
                                        // Satellizer promise reject error.
                                    } else if (error.data) {
                                        // HTTP response error from server
                                        $scope.error = error.data
                                    } else {
                                        $scope.error = error
                                    }
                                });
                        };
                    }]
                ,
                data: {
                    login_required: false
                }
            })
            .state('amt.auth', {
                url: '/auth',
                abstract: true,
                template: "<div ui-view></div>",
                data: {
                    title: "Auth"
                },
                menu: {
                    position: 'top',
                    fa_icon: "user",
                    childs: [
                        // {state: 'amt.auth.profile', glyphicon: 'user'},
                        {state: 'amt.auth.logout', glyphicon: 'log-out'}
                    ]
                }
            })
            .state('amt.auth.logout', {
                url: '/logout',
                template: null,
                data: {
                    title: 'Logout'
                },
                controller: ['$location', '$auth', '$state', function ($location, $auth, $state) {
                    if (!$auth.isAuthenticated()) {
                        return;
                    }
                    $auth.logout()
                        .then(function () {
                            $state.go('login');
                        });
                }]
            })
            .state('amt.denied', {
                url: '/denied',
                template: '<h1>Denied</h1>'
            });
        $urlRouterProvider.otherwise('/');
    }]);


app.run(['APP_CONFIG', '$rootScope', 'currentUser', '$state', '$auth',
    function (APP_CONFIG, $rootScope, currentUser, $state, $auth) {
        $rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams, options) {
                var state_data = $state.get(toState.name).data || {login_required: true, role: 'any'};
                var state_login_required = state_data.login_required != undefined ? state_data.login_required : true;

                if (!$auth.isAuthenticated() && state_login_required) {
                    event.preventDefault();
                    return $state.go('login', {state: toState.name, state_params: angular.toJson(toParams)});
                }
                return;
            });

        $rootScope.$on('$stateChangeSuccess',
            function (event, toState, toParams, fromState, fromParams) {
                var state_data = $state.get(toState.name).data || {login_required: true, role: 'any'};
                var can_open = state_data && state_data.role_need ? currentUser.can(state_data.role) : true;
                if (!can_open) {
                    event.preventDefault();
                    return $state.go('amt.denied');
                }
                return;
            })

    }]);

export default app.name;
